import { PayoutsHistory as Component } from './PayoutsHistory';
import { withState } from './PayoutsHistory.state';

export const PayoutsHistory = withState(Component);
